import { render, staticRenderFns } from "./AccountForm.vue?vue&type=template&id=2ed070cf&scoped=true"
import script from "./AccountForm.vue?vue&type=script&lang=js"
export * from "./AccountForm.vue?vue&type=script&lang=js"
import style0 from "./AccountForm.vue?vue&type=style&index=0&id=2ed070cf&prod&lang=scss&scoped=true"
import style1 from "./AccountForm.vue?vue&type=style&index=1&id=2ed070cf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ed070cf",
  null
  
)

export default component.exports